import React from 'react';

const ShareIcon = ({
  className,
  href,
  ariaLabel,
  handleClick,
  icon: IconComponent,
  alt,
}) => (
  <li className={className}>
    <a
      href={href}
      alt={alt}
      aria-label={ariaLabel}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <IconComponent />
    </a>
  </li>
);

export default ShareIcon;
